<p class="text-muted mb-15" style="font-size: 13px;">
  Los campos que espera la API de CIMA son un contrato del proveedor externo que no vive en este
  repo. Pega aquí el payload en JSON (los mismos datos que llegarían desde el WhatsApp Flow) y
  verás el score y el grupo calculado, exactamente igual que
  <code>chatbot_v1/flows/CimaFlow.js</code> — sin actualizar ningún participante.
</p>

<mat-form-field appearance="fill" class="full-width">
  <mat-label>Payload (JSON)</mat-label>
  <textarea matInput rows="8" [(ngModel)]="payloadJson"></textarea>
</mat-form-field>

<div class="text-right" style="text-align: right;">
  <button mat-button class="default-btn" type="button" (click)="reset()">Limpiar</button>
  <button
    mat-raised-button
    class="default-btn bg-main-color-blue"
    type="button"
    [disabled]="isLoading"
    (click)="onSubmit()"
  >
    {{ isLoading ? "Consultando..." : "Consultar CIMA" }}
  </button>
</div>

<div *ngIf="errorMessage" class="alert-message error-message mt-15">
  {{ errorMessage }}
</div>

<div *ngIf="result" class="result-card mt-15">
  <h5 class="title-color">📊 Resultado</h5>
  <p><strong>Score (FH):</strong> {{ result.score }}</p>
  <p><strong>Grupo asignado:</strong> {{ result.group }}</p>
  <pre class="raw-json">{{ result.raw | json }}</pre>
</div>
